import {Typography} from '@yandex-delivery/blocks'
import clsx from 'clsx'
import type {PropsWithChildren, ReactElement} from 'react'

import * as classes from './PointMarkerIcon.classes'
import type {PointMarkerType} from './types'

type Props = PropsWithChildren<{
  type?: PointMarkerType
  draggable?: boolean
  dragging?: boolean
  className?: string
}>

export function PointMarkerIcon(props: Props): ReactElement {
  const {dragging, draggable, className} = props
  const children = renderIcon(props)

  return (
    <div className={clsx(classes.marker, className)}>
      {draggable ? (
        <div className={clsx(classes.draggable, dragging && classes.dragging)}>
          {children}
          {<div className={clsx(classes.stick, dragging && classes.stickDragging)} />}
        </div>
      ) : (
        children
      )}
    </div>
  )
}

function renderIcon({type, children}: Props): ReactElement {
  const className = clsx(classes.icon, type && classes.iconType[type])

  switch (type) {
    case 'numeric': {
      return (
        <Typography className={className} color="inherit" Component="div" justifyContent="center" variant="body2">
          {children}
        </Typography>
      )
    }
  }

  return <div className={className} />
}
